
import { ImportDataClient } from '@/services/Services';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/Model';

@Options({})
export default class ImportErrorsModal extends Vue {

    @Prop() importId: string;

    detail: OM.ImportDetailVM = null;

    created() {
        ImportDataClient.getImportById(this.importId)
        .then(x => {
            this.detail = x;
        });
    }

}
